import { QrCodeDownLoader } from "../../../organisms/QrCodeDownLoader";


export const VisitQrCode = () => {
  return <QrCodeDownLoader liffType='visit' />
};